import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'
import type { WithId } from '@/types/common'

import { AccountDto, AccountSelectDto, type AccountRole, type AccountStatus } from './account-dto'

export const accountApi = {
  detail: apiFactory({
    url: ENDPOINT.account.user.detail,
    method: 'get',
    schema: {
      result: apiOk(z.object({ account: AccountDto })),
    },
  }),
}

interface AccountMutationBody {
  name: string
  email: string
  status: AccountStatus
  pin: string
  password: string
  isRoot: boolean
  outlets: {
    oId: string
    role: AccountRole
    isDefault: boolean
  }[]
}

export const accountAdminApi = {
  list: apiFactory({
    url: ENDPOINT.account.admin.list,
    method: 'get',
    schema: {
      result: apiOk(z.object({ accounts: AccountSelectDto.array() })),
    },
  }),
  detail: apiFactory({
    url: ENDPOINT.account.admin.detail,
    method: 'get',
    schema: {
      params: z.custom<WithId>(),
      result: apiOk(z.object({ account: AccountDto })),
    },
  }),
  create: apiFactory({
    url: ENDPOINT.account.admin.create,
    method: 'post',
    schema: {
      body: z.custom<AccountMutationBody>(),
    },
  }),
  update: apiFactory({
    url: ENDPOINT.account.admin.update,
    method: 'put',
    schema: {
      body: z.custom<WithId<AccountMutationBody>>(),
    },
  }),
  remove: apiFactory({
    url: ENDPOINT.account.admin.remove,
    method: 'delete',
    schema: {
      params: z.custom<{ id: string }>(),
    },
  }),
}
